<template>
  <section class="container page-py blog" dir="ltr">
    <h1>{{ $t('blogTitle') }}</h1>
    <h3>{{ $t('blogSubtitle') }}</h3>
    <div class="blog__content">
      <ui-link
        v-for="article in mockArticles"
        :key="article.id"
        class="blog-card"
        :to="article.link"
      >
        <div class="blog-card__image">
          <img :src="article.image" :alt="$t(article.altImage)" />
        </div>
        <div class="blog-card__content">
          <div class="time" v-if="article.date">
            {{ $t(article.date) }}
          </div>
          <p class="title">{{ $t(article.title) }}</p>
          <div class="likes" v-if="article.countLike"></div>
        </div>
      </ui-link>
    </div>
  </section>
</template>

<script setup lang="ts">
import {useRuntimeConfig} from '#imports';
import {useI18n} from 'vue-i18n';

const {locale} = useI18n();
const router = useRouter();
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const mockArticles = [
  {
    id: 34,
    image: `${staticUrl}/images/blog/Introducing_an_Exceptional_Home_Design_Software_Explore_the_Latest_Innovations_in_Room_Design_Solutions.webp`,
    altImage: 'altImageDefault',
    date: 'artTime34',
    title: 'artTitle34',
    link: `/${locale.value}/blog/Introducing_an_Exceptional_Home_Design_Software_Explore_the_Latest_Innovations_in_Room_Design_Solutions`,
    countLike: null,
  },
  {
    id: 33,
    image: `${staticUrl}/images/blog/This_Home_Design_App_is_Key_To_Your_Studio_Apartment_Inspiration.webp`,
    altImage: 'altImageDefault',
    date: 'artTime33',
    title: 'artTitle33',
    link: `/${locale.value}/blog/This_Home_Design_App_is_Key_To_Your_Studio_Apartment_Inspiration`,
    countLike: null,
  },
  {
    id: 32,
    image: `${staticUrl}/images/blog/Quest_for_the_Perfect_Home_Design_Solution.webp`,
    altImage: 'altImageDefault',
    date: 'artTime32',
    title: 'artTitle32',
    link: `/${locale.value}/blog/Quest_for_the_Perfect_Home_Design_Solution`,
    countLike: null,
  },
  {
    id: 31,
    image: `${staticUrl}/images/blog/Enhancing_Your_Apartment_with_Contemporary_Design_Solutions_for_Windows_PC.webp`,
    altImage: 'altImageDefault',
    date: 'artTime31',
    title: 'artTitle31',
    link: `/${locale.value}/blog/Enhancing_Your_Apartment_with_Contemporary_Design_Solutions_for_Windows_PC`,
    countLike: null,
  },
  {
    id: 30,
    image: `${staticUrl}/images/blog/Home_Interiors_A_Fresh_Perspective_on_Design_Solutions.webp`,
    altImage: 'altImageDefault',
    date: 'artTime30',
    title: 'artTitle30',
    link: `/${locale.value}/blog/Home_Interiors_A_Fresh_Perspective_on_Design_Solutions`,
    countLike: null,
  },
  {
    id: 29,
    image: `${staticUrl}/images/blog/Design_Your_Room_Easily_Even_If_You_re_New_to_Interior_Design.webp`,
    altImage: 'altImageDefault',
    date: 'artTime29',
    title: 'artTitle29',
    link: `/${locale.value}/blog/Design_Your_Room_Easily_Even_If_You_re_New_to_Interior_Design`,
    countLike: null,
  },
  {
    id: 28,
    image: `${staticUrl}/images/blog/A_Comprehensive_Interior_Design_App_Suite_Ignite_Your_Design_Spark.webp`,
    altImage: 'altImageDefault',
    date: 'artTime28',
    title: 'artTitle28',
    link: `/${locale.value}/blog/A_Comprehensive_Interior_Design_App_Suite_Ignite_Your_Design_Spark`,
    countLike: null,
  },
  {
    id: 27,
    image: `${staticUrl}/images/blog/Contemporary_Design_Trends_Implement_Any_Ideas_with_an_Innovative_Application.webp`,
    altImage: 'altImageDefault',
    date: 'artTime27',
    title: 'artTitle27',
    link: `/${locale.value}/blog/Contemporary_Design_Trends_Implement_Any_Ideas_with_an_Innovative_Application`,
    countLike: null,
  },
  {
    id: 26,
    image: `${staticUrl}/images/blog/3D_Interior_Design_Dive_Into_New_World_with_This_App.webp`,
    altImage: 'altImageDefault',
    date: 'artTime26',
    title: 'artTitle26',
    link: `/${locale.value}/blog/3D_Interior_Design_Dive_Into_New_World_with_This_App`,
    countLike: null,
  },
  {
    id: 25,
    image: `${staticUrl}/images/blog/Home_Design_App_Guide_Step_Into_Your_Dream.webp`,
    altImage: 'altImageDefault',
    date: 'artTime25',
    title: 'artTitle25',
    link: `/${locale.value}/blog/Home_Design_App_Guide_Step_Into_Your_Dream`,
    countLike: null,
  },
  {
    id: 24,
    image: `${staticUrl}/images/blog/DreamFlat_Your_Handy_Room_Blueprint_Maker.webp`,
    altImage: 'altImageDefault',
    date: 'artTime24',
    title: 'artTitle24',
    link: `/${locale.value}/blog/DreamFlat_Your_Handy_Room_Blueprint_Maker`,
    countLike: null,
  },
  {
    id: 23,
    image: `${staticUrl}/images/blog/10_Spa_tastic_Modern_Bathroom_Floor_Tile_Ideas_to_Elevate_Your_Home_Spa_Experience.webp`,
    altImage: 'altImageDefault',
    date: 'artTime23',
    title: 'artTitle23',
    link: `/${locale.value}/blog/10_Spa_tastic_Modern_Bathroom_Floor_Tile_Ideas_to_Elevate_Your_Home_Spa_Experience`,
    countLike: null,
  },
  {
    id: 22,
    image: `${staticUrl}/images/blog/DreamFlat_A_Modern_Room_Design_Software.webp`,
    altImage: 'altImageDefault',
    date: 'artTime22',
    title: 'artTitle22',
    link: `/${locale.value}/blog/DreamFlat_A_Modern_Room_Design_Software`,
    countLike: null,
  },
  {
    id: 21,
    image: `${staticUrl}/images/blog/Step_into_the_Future_5_Modern_Kitchen_Floor_Tile_Ideas_for_2024_with_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime21',
    title: 'artTitle21',
    link: `/${locale.value}/blog/Step_into_the_Future_5_Modern_Kitchen_Floor_Tile_Ideas_for_2024_with_DreamFlat`,
    countLike: null,
  },
  {
    id: 20,
    image: `${staticUrl}/images/blog/DreamFlat_A_Perfect_Room_Planner.webp`,
    altImage: 'altImageDefault',
    date: 'artTime20',
    title: 'artTitle20',
    link: `/${locale.value}/blog/DreamFlat_A_Perfect_Room_Planner`,
    countLike: null,
  },
  {
    id: 19,
    image: `${staticUrl}/images/blog/Create_Your_Ultimate_Relaxation_Retreat_Realizing_Master_Bathroom_Ideas_with_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime19',
    title: 'artTitle19',
    link: `/${locale.value}/blog/Create_Your_Ultimate_Relaxation_Retreat_Realizing_Master_Bathroom_Ideas_with_DreamFlat`,
    countLike: null,
  },
  {
    id: 18,
    image: `${staticUrl}/images/blog/Small_Kitchen_Ideas_Smart_Solutions_for_Space_and_Style_with_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime18',
    title: 'artTitle18',
    link: `/${locale.value}/blog/Small_Kitchen_Ideas_Smart_Solutions_for_Space_and_Style_with_DreamFlat`,
    countLike: null,
  },
  {
    id: 17,
    image: `${staticUrl}/images/blog/Tap_into_Your_Inner_Artist_Crafting_Your_Bathroom_Design_Using_State_of_the_Art_Tools.webp`,
    altImage: 'altImageDefault',
    date: 'artTime17',
    title: 'artTitle17',
    link: `/${locale.value}/blog/Tap_into_Your_Inner_Artist_Crafting_Your_Bathroom_Design_Using_State_of_the_Art_Tools`,
    countLike: null,
  },
  {
    id: 16,
    image: `${staticUrl}/images/blog/10_Bedroom_Color_Ideas_to_Enhance_Your_Dream_Space_with_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime16',
    title: 'artTitle16',
    link: `/${locale.value}/blog/10_Bedroom_Color_Ideas_to_Enhance_Your_Dream_Space_with_DreamFlat`,
    countLike: null,
  },
  {
    id: 15,
    image: `${staticUrl}/images/blog/10_Luxury_Modern_Kitchen_Design_Ideas_Brought_to_Life_with_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime15',
    title: 'artTitle15',
    link: `/${locale.value}/blog/10_Luxury_Modern_Kitchen_Design_Ideas_Brought_to_Life_with_DreamFlat`,
    countLike: null,
  },
  {
    id: 14,
    image: `${staticUrl}/images/Tiny_Space_Big_Dreams_Unlocking_Studio_Apartment_Ideas_Potential_with_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime14',
    title: 'artTitle14',
    link: `/${locale.value}/blog/Tiny_Space_Big_Dreams_Unlocking_Studio_Apartment_Ideas_Potential_with_DreamFlat`,
    countLike: null,
  },
  {
    id: 13,
    image: `${staticUrl}/images/Unlocking_New_Horizons_for_Creative_Industries_with_DreamFlats_Innovative 3D_Room_Design_Platform.webp`,
    altImage: 'altImageDefault',
    date: 'artTime13',
    title: 'artTitle13',
    link: `/${locale.value}/blog/Unlocking_New_Horizons_for_Creative_Industries_with_DreamFlats_Innovative_3D_Room_Design_Platform`,
    countLike: null,
  },
  {
    id: 12,
    image: `${staticUrl}/images/Spruce_Up_Your_Space_Top_Office_Decor_Ideas_Brought_to_Life_by_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime12',
    title: 'artTitle12',
    link: `/${locale.value}/blog/Spruce_Up_Your_Space_Top_Office_Decor_Ideas_Brought_to_Life_by_DreamFlat`,
    countLike: null,
  },
  {
    id: 11,
    image: `${staticUrl}/images/DreamFlat_Unleashing_Your_Inner_Design_Guru_with_Free_Furniture_Arrangement_Magic.webp`,
    altImage: 'altImageDefault',
    date: 'artTime11',
    title: 'artTitle11',
    link: `/${locale.value}/blog/DreamFlat_Unleashing_Your_Inner_Design_Guru_with_Free_Furniture_Arrangement_Magic`,
    countLike: null,
  },
  {
    id: 10,
    image: `${staticUrl}/images/DreamFlat_Design_Kitchen_in_Pixel-Perfect_Detail.webp`,
    altImage: 'altImageDefault',
    date: 'artTime10',
    title: 'artTitle10',
    link: `/${locale.value}/blog/DreamFlat_Design_Kitchen_in_Pixel-Perfect_Detail`,
    countLike: null,
  },
  {
    id: 9,
    image: `${staticUrl}/images/DreamFlat_Where_Your_Dream_Home_Takes_Flight.webp`,
    altImage: 'altImageDefault',
    date: 'artTime9',
    title: 'artTitle9',
    link: `/${locale.value}/blog/DreamFlat_Where_Your_Dream_Home_Takes_Flight`,
    countLike: null,
  },
  {
    id: 8,
    image: `${staticUrl}/images/Revolutionizing_Spatial_Design_with_DreamFlat_A_Seamless_Approach_to_Floor_Planning.webp`,
    altImage: 'altImageDefault',
    date: 'artTime8',
    title: 'artTitle8',
    link: `/${locale.value}/blog/Revolutionizing_Spatial_Design_with_DreamFlat_A_Seamless_Approach_to_Floor_Planning`,
    countLike: null,
  },
  {
    id: 7,
    image: `${staticUrl}/images/DreamFlat_Revolutionizing_Interior_Design_with_Cutting-Edge_3D_Room_Planning.webp`,
    altImage: 'altImageDefault',
    date: 'artTime7',
    title: 'artTitle7',
    link: `/${locale.value}/blog/DreamFlat_Revolutionizing_Interior_Design_with_Cutting-Edge_3D_Room_Planning`,
    countLike: null,
  },
  {
    id: 6,
    image: `${staticUrl}/images/5_Best_Ideas_of_House_Exteriors.webp`,
    altImage: 'altImageDefault',
    date: 'artTime6',
    title: 'artTitle6',
    link: `/${locale.value}/blog/5_Best_Ideas_of_House_Exteriors`,
    countLike: null,
  },
  {
    id: 5,
    image: `${staticUrl}/images/10_Kitchen_Layout_Ideas_Unleash_Your_Culinary_Creativity_with_DreamFlat.webp`,
    altImage: 'altImageDefault',
    date: 'artTime5',
    title: 'artTitle5',
    link: `/${locale.value}/blog/10_Kitchen_Layout_Ideas_Unleash_Your_Culinary_Creativity_with_DreamFlat`,
    countLike: null,
  },
  {
    id: 4,
    image: `${staticUrl}/images/DreamFlat-A-New-Player-at-Home-Design-Software-Market.webp`,
    altImage: 'altImageDefault',
    date: 'artTime4',
    title: 'artTitle4',
    link: `/${locale.value}/blog/DreamFlat-a-New-Player-at-Home-Design-Software-Market`,
    countLike: null,
  },
  {
    id: 3,
    image: `${staticUrl}/images/DreamFlat-Home-Design-Software-A-Revolutionizing-Tool.webp`,
    altImage: 'altImageDefault',
    date: 'artTime3',
    title: 'artTitle3',
    link: `/${locale.value}/blog/DreamFlat-Home-Design-Software-A-Revolutionizing-Tool`,
    countLike: null,
  },
  {
    id: 2,
    image: `${staticUrl}/images/DreamFlat-A-Free-and-Comprehensive-Interior-Design-Tool.webp`,
    altImage: 'altImageDefault',
    date: 'artTime2',
    title: 'artTitle2',
    link: `/${locale.value}/blog/DreamFlat-A-Free-and-Comprehensive-Interior-Design-Tool`,
    countLike: null,
  },
  {
    id: 1,
    image: `${staticUrl}/images/DreamFlat-Innovative-Home-Design-Software.webp`,
    altImage: 'altImageDefault',
    date: 'artTime1',
    title: 'artTitle1',
    link: `/${locale.value}/blog/DreamFlat-Innovative-Home-Design-Software`,
    countLike: null,
  },
];
</script>

<style scoped lang="scss">
.blog {
  min-height: calc(100vh - 55px);
  display: flex;
  align-items: center;
  flex-direction: column;

  &__content {
    width: 100%;
    margin-top: $m-14;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: $g-12;
    row-gap: $g-20;
    .blog-card {
      width: 100%;
      border-radius: 16px;
      background: var(--var-white-100);
      cursor: pointer;

      &__image {
        img {
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
          width: 100%;
          object-fit: cover;
        }
      }

      &__content {
        padding: $p-4;
        .time {
          @include launcher-p3;
          color: var(--var-gray-200);
        }
        .title {
          @include subtitle-fs-18-fw-700-black-100;
        }
      }
    }

    @media (max-width: $md) {
      grid-template-columns: 1fr;
      row-gap: $g-10;
    }
  }
}

h1 {
  @include headline-h1;
}
h3 {
  @include launcher-p1;
  margin-top: 0px;
}
</style>
